export default {
    name: "DataTableSearchFilter",

    props: {
        searchText: String,
        search: String,
    }
};
